export enum PatientRelationship {
  MOTHER = "MOTHER",
  FATHER = "FATHER",
  DAUGHTER = "DAUGHTER",
  SON = "SON",
  OTHER_FAMILY_MEMBER = "OTHER_FAMILY_MEMBER",
  SIBLING = "SIBLING",
  LEGAL_GUARDIAN = "LEGAL_GUARDIAN",
}

export const patientRelationshipOrdered = [
  PatientRelationship.MOTHER,
  PatientRelationship.FATHER,
  PatientRelationship.DAUGHTER,
  PatientRelationship.SON,
  PatientRelationship.OTHER_FAMILY_MEMBER,
  PatientRelationship.SIBLING,
  PatientRelationship.LEGAL_GUARDIAN,
];

export function getI18NKey(relationship: PatientRelationship) {
  switch (relationship) {
    case PatientRelationship.MOTHER:
      return "PatientRelationship.Mother";
    case PatientRelationship.FATHER:
      return "PatientRelationship.Father";
    case PatientRelationship.DAUGHTER:
      return "PatientRelationship.Daughter";
    case PatientRelationship.SON:
      return "PatientRelationship.Son";
    case PatientRelationship.OTHER_FAMILY_MEMBER:
      return "PatientRelationship.OtherFamilyMember";
    case PatientRelationship.SIBLING:
      return "PatientRelationship.Sibling";
    case PatientRelationship.LEGAL_GUARDIAN:
      return "PatientRelationship.LegalGuardian";
  }
}
